import { useInterstateTheme } from '../../InterstateThemeProvider';
import { meatBallSplitButtonStyleBuilder } from './splitButtonStyleBuilder';
import { EllipsisHorizontalIcon } from '../../Icons';
import { Button } from '../../Button';
import { Menu, useMenu } from '../../Menu';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const MeatBallButton = _ref => {
  let {
    buttonStyle,
    disabled,
    id,
    options,
    size,
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  const menuProps = useMenu();
  const menuItemOptions = options.map((_ref2, index) => {
    let {
      onSelect,
      value,
      id,
      label,
      disabled,
      divider
    } = _ref2;
    return {
      value,
      label,
      id,
      disabled,
      divider,
      onSelect
    };
  });
  const _menu = /*#__PURE__*/_jsx(Menu, {
    referenceProps: menuProps.referenceProps,
    menuOptions: menuItemOptions,
    size: size,
    position: "bottom-end"
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      buttonStyle: buttonStyle,
      disabled: disabled,
      id: `${id}-meatBallButton`,
      size: size,
      startIcon: /*#__PURE__*/_jsx(EllipsisHorizontalIcon, {}),
      onClick: menuProps.onClick,
      sx: meatBallSplitButtonStyleBuilder(theme, buttonStyle, disabled),
      "data-testid": rest['data-testid'] ? `${rest['data-testid']}-meatBallButton` : 'meatBallButton-component'
    }), _menu]
  });
};